const animElements = {

    init () {
        // console.log('anim elements');

        var listElements = document.querySelectorAll('.anim-from-right');


        // console.log(listElements);
    }

}
export default animElements;
